var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    className: "fill-white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 7.33386H10L7.80659 5.14053C7.7441 5.07855 7.69451 5.00482 7.66066 4.92358C7.62681 4.84234 7.60939 4.7552 7.60939 4.66719C7.60939 4.57919 7.62681 4.49205 7.66066 4.41081C7.69451 4.32957 7.7441 4.25584 7.80659 4.19386C7.9315 4.06969 8.10046 4 8.27659 4C8.45271 4 8.62168 4.06969 8.74659 4.19386L11.6066 7.06052C11.857 7.30942 11.9984 7.64747 12 8.00052C11.9968 8.35126 11.8555 8.68659 11.6066 8.93386L8.74659 11.8005C8.68443 11.8622 8.61072 11.9111 8.52967 11.9443C8.44863 11.9776 8.36183 11.9945 8.27423 11.9942C8.18663 11.9939 8.09996 11.9764 8.01915 11.9425C7.93833 11.9087 7.86497 11.8593 7.80325 11.7972C7.74153 11.735 7.69266 11.6613 7.65942 11.5803C7.62619 11.4992 7.60924 11.4124 7.60955 11.3248C7.60986 11.2372 7.62742 11.1506 7.66123 11.0697C7.69503 10.9889 7.74443 10.9156 7.80659 10.8539L10 8.66719H3.33325C3.15644 8.66719 2.98687 8.59695 2.86185 8.47193C2.73683 8.3469 2.66659 8.17733 2.66659 8.00052C2.66659 7.82371 2.73683 7.65414 2.86185 7.52912C2.98687 7.4041 3.15644 7.33386 3.33325 7.33386Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6d9418a513c2e99ec8a82530169c2e4c.svg";
export { ForwardRef as ReactComponent };